import KDSBranch from 'pages/kds/kdsbranches';
import React from 'react';

function BranchView(props) {
  return <KDSBranch />;
}

export default BranchView;
